import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { serviceTypes } from './ServiceTypes';
import useCommonNavigations from '../../hooks/Navigation';
import { ServiceListProps, serviceParams } from './common';
import Block from '../../components/common/Block';
import theme from '../../conf/theme';
import { blue } from '@mui/material/colors';
import SendIcon from '@mui/icons-material/Send';

export const serviceItemCss = () => {
  const serviceItemCss = {
    rootContainer: {
      //backgroundColor: 'blue',
      width: '400px',
      paddingRight: '5px',
      [theme.breakpoints.down('md')]: {
        //backgroundColor: 'red',
        width: '100%',
        paddingRight: '0px',
      },
    },
    container: {
      flexGrow: 1,
      padding: '10px',
    },
    root: {
      flexGrow: 1,
    },
    title: {
      fontSize: theme.typography.pxToRem(12),
      textAlign: 'center',
      fontWeight: 'bold',
    },
    logo: {
      textAlign: 'center',
      width: 'auto',
      height: 100,
    },
    divider: {
      borderBottomWidth: 2,
    },
    dividerStrong: {
      //backgroundColor : blue[500],
    },
    spaceer: {
      paddingTop: theme.spacing(1),
    },
    subtitle: {
      fontSize: theme.typography.pxToRem(11),
      fontWeight: 'bold',
      color: theme.palette.text.secondary,
    },
    footnote: {
      fontSize: theme.typography.pxToRem(12),
      textAlign: 'center',
      paddingTop: theme.spacing(1),
    },
    receiptColor: {
      //color: blue[700],
    },
    footNoteColor: {
      color: blue[700],
    },
    label: {
      fontSize: theme.typography.pxToRem(15),
      textAlign: 'center',
      fontWeight: 'bold',
    },
    regularLabel: {
      fontSize: theme.typography.pxToRem(13),
      textAlign: 'center',
      fontWeight: 'bold',
    },
    smallText: {
      fontSize: theme.typography.pxToRem(14),
    },
    bold: {
      fontWeight: 'bold',
    },
    smallTextBold: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 'bold',
    },
    receiptBody: {
      fontSize: theme.typography.pxToRem(12),
    },
    extraSpace: {
      paddingTop: theme.spacing(2),
    },
  };
  return serviceItemCss;
};

type ServiceItemProps = {
  title: string;
  serviceId: number;
  serviceType: string;
  description: string;
  merchant: string;
  category: string;
  handleClick: (formType: string, merchant: string, serviceId: number) => void;
};

const ServiceItem = (props: ServiceItemProps) => {
  const cssStyle = serviceItemCss();
  return (
    <Grid container sx={cssStyle.rootContainer}>
      <Grid item alignContent={'center'} xs={12} lg={12}>
        <Block title={props.title}>
          <Grid container direction="column" spacing={1}>
            <Grid item>
              <Typography variant="subtitle2" sx={cssStyle.subtitle}>
                {props.merchant}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="subtitle2" sx={cssStyle.subtitle}>
                {props.category}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="subtitle2" sx={cssStyle.subtitle}>
                {props.description}
              </Typography>
            </Grid>
            <Grid item>
              <Button
                variant="text"
                startIcon={<SendIcon />}
                onClick={() =>
                  props.handleClick(
                    serviceTypes[props.serviceType].dataForm,
                    props.merchant,
                    props.serviceId
                  )
                }
              >
                Search Bills
              </Button>
            </Grid>
          </Grid>
        </Block>
      </Grid>
    </Grid>
  );
};

const ServiceList = (props: ServiceListProps) => {
  const { goToServiceIntakeForm } = useCommonNavigations();
  //const [isOpenCollapse, setIsOpenCollapse] = React.useState<number>(-1);
  const supportedServices = [1001, 2000, 90007, 202303];
  const query = props.query;
  const searchText = props.searchText;
  const services = query.services || [];
  //const groups: string[] = [];

  let serviceList = services.filter((svc) => {
    let idx = 1;
    let active = false;
    if (svc) {
      if (searchText) {
        idx =
          Math.max(
            svc?.description?.toLowerCase()?.indexOf(searchText) || 0,
            0
          ) +
          Math.max(svc?.merchant?.toLowerCase()?.indexOf(searchText) || 0, 0) +
          Math.max(svc?.title?.toLowerCase()?.indexOf(searchText) || 0, 0);
      }
      if (svc.type) {
        active = serviceTypes[svc.type].active;
      }
    }
    return (
      active && idx > 0 && supportedServices.indexOf(svc?.serviceid || 0) > -1
    );
  });

  /*
  const byServiceType = services.reduce(
    (acc: { [key: string]: typeof req[] }, req) => {
      if (!req) return acc;
      const serviceType = req.type;
      const labelServiceNumber = req.labelServiceNumber;
      const labelCustomerNumber = req.labelCustomerNumber;
      if (
        serviceTypes[serviceType].active &&
        (labelCustomerNumber || labelServiceNumber)
      ) {
        if (!acc[serviceType]) {
          groups.push(serviceType);
          acc[serviceType] = [];
        }
        acc[serviceType].push(req);
      }
      return acc;
    },
    {}
  );

  const handleClick = (clickedIndex: number) => {
    if (isOpenCollapse === clickedIndex) {
      setIsOpenCollapse(-1);
    } else {
      setIsOpenCollapse(clickedIndex);
    }
  }; */

  const goToService = (
    serviceType: string,
    merchant: string,
    serviceId: number
  ) => {
    serviceParams({
      merchant,
      serviceId,
    });
    goToServiceIntakeForm(serviceType, serviceId);
  };

  return (
    <Box sx={{ pt: 1, flexGrow: 1 }}>
      {services.length === 0 && (
        <Typography
          variant="subtitle2"
          sx={{ mt: 2, ml: 0, mb: 2, fontSize: 12, fontWeight: 'bold' }}
          id="requestList"
        >
          No Available services
        </Typography>
      )}
      <Grid container>
        {serviceList.map((x) => (
          <ServiceItem
            key={x?.serviceid}
            serviceId={x?.serviceid || 0}
            handleClick={goToService}
            serviceType={x?.type || ''}
            title={x?.title || ''}
            category={x?.category || ''}
            description={x?.description || ''}
            merchant={x?.merchant || ''}
          />
        ))}
      </Grid>
    </Box>
  );
};

export default ServiceList;
